import { Component, Input } from '@angular/core';
import { IFileErrors } from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';

@Component({
	selector: 'au-file-error-viewer',
	templateUrl: './au-file-error-viewer.component.html',
	styleUrls: ['./au-file-error-viewer.component.scss'],
	imports: [],
})
export class AuFileErrorViewerComponent {
	@Input() errors: Partial<IFileErrors>;

	errorFormatter(serverError: string) {
		const splittedByDotError = serverError.split('.');

		if (splittedByDotError.length > 1) {
			const firstSegment = splittedByDotError[0];
			splittedByDotError[0] = `<b>${firstSegment}</b>`;

			return splittedByDotError.join('.');
		}

		return serverError;
	}
}
